import React, { Fragment, useState } from 'react';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { AboutIncentivesContent } from 'site-modules/shared/components/incentives/about-incentives-content/about-incentives-content';

import './about-incentives-modal.scss';

const CREATIVE_ID = 'car-incentives-about-modal';

export function AboutIncentivesModal() {
  const [isOpen, setIsOpen] = useState(false);

  function toggleModal() {
    if (isOpen) {
      EventToolbox.fireTrackAction({
        event_type: 'action_completed',
        event_data: {
          action_name: TrackingConstant.ACTION_RESET_NAVIGATION,
          subaction_name: TrackingConstant.NAVIGATION_CLOSE,
          action_category: TrackingConstant.USER_ACTION_CATEGORY,
          action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
          creative_id: CREATIVE_ID,
        },
      });
    }

    setIsOpen(!isOpen);
  }

  return (
    <Fragment>
      <Button
        color="link"
        onClick={toggleModal}
        rel="nofollow"
        className="d-inline-block learn-more-incentives p-0 text-transform-none"
        data-tracking-parent={CREATIVE_ID}
        data-tracking-id="link_select_tool_select"
      >
        Learn more about Incentives
      </Button>
      <Modal
        size="lg"
        className="about-incentives-modal py-2 my-0 h-100"
        contentClassName="h-100"
        isOpen={isOpen}
        toggle={toggleModal}
      >
        <ModalHeader tag="div" className="text-gray-dark d-block">
          <div className="heading-3 pe-2">About Incentives and Rebates</div>
          <Button
            color="link"
            size="lg"
            className="btn-close p-0_75 text-decoration-none"
            aria-label="Close"
            onClick={toggleModal}
          >
            <i className="icon-cross2 size-16" aria-hidden />
          </Button>
        </ModalHeader>
        <ModalBody id="about-incentives" className="pe-1_5">
          <AboutIncentivesContent containerId="about-incentives" collapseLongItems />
        </ModalBody>
      </Modal>
    </Fragment>
  );
}
